"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tabs = require("./Tabs.styled");
var _focus = require("@react-aria/focus");
var _jsxRuntime = require("react/jsx-runtime");
var Tabs = function Tabs(_ref) {
  var value = _ref.value,
    onValueChange = _ref.onValueChange,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabsStyled, {
    value: value,
    defaultValue: value,
    onValueChange: onValueChange,
    children: children
  });
};
var List = function List(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabListStyled, {
    children: children
  });
};
var Tab = function Tab(props) {
  var value = props.value,
    children = props.children,
    rest = _objectWithoutProperties(props, ["value", "children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_focus.FocusRing, {
    focusRingClass: "focus-ring",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabStyled, _objectSpread({}, rest, {
      value: value,
      children: children
    }))
  });
};
var Content = function Content(_ref3) {
  var value = _ref3.value,
    children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.TabContentStyled, {
    value: value,
    children: children
  });
};
Tabs.Tab = Tab;
Tabs.List = List;
Tabs.Content = Content;
var _default = exports.default = Tabs;